<svg-icon key="refresh" tooltip="Reset context" />
